import PassportRecordRequirementHealthcareItem from "./PassportRecordRequirementHealthcareItem";

export default PassportRecordRequirementHealthcareItem;